module.exports = __webpack_public_path__ + "sr.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/sr.svg
// module id = 1071
// module chunks = 0